import { render } from "./OnlinePage.vue?vue&type=template&id=77015656&scoped=true&ts=true"
import script from "./OnlinePage.vue?vue&type=script&lang=ts"
export * from "./OnlinePage.vue?vue&type=script&lang=ts"

import "./OnlinePage.vue?vue&type=style&index=0&id=77015656&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77015656"]])

export default __exports__